import { render, staticRenderFns } from "./TransactionConfirmationNew.vue?vue&type=template&id=40f534c4&"
import script from "./TransactionConfirmationNew.vue?vue&type=script&lang=js&"
export * from "./TransactionConfirmationNew.vue?vue&type=script&lang=js&"
import style0 from "./TransactionConfirmationNew.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports